// @tennis-matches/services/masterdata/club-person-billing-assignment-errors

function __asStr(v) {
  return String(v ?? "").trim();
}

/**
 * @param {unknown} error
 * @returns {string}
 */
export function extractClubPersonBillingAssignmentReason(error) {
  const parts = [];
  if (error && typeof error === "object") {
    const e = /** @type {Record<string, unknown>} */ (error);
    parts.push(e.reason, e.message, e.details, e.hint);
    if (e.error && typeof e.error === "object") {
      const nested = /** @type {Record<string, unknown>} */ (e.error);
      parts.push(nested.message, nested.details, nested.hint);
    }
  } else if (error != null) {
    parts.push(error);
  }

  for (const raw of parts) {
    const text = __asStr(raw);
    if (!text) continue;
    if (text.includes("billing-recipient-already-assigned")) return "billing-recipient-already-assigned";
    if (text.includes("guardian-already-assigned")) return "guardian-already-assigned";
    if (text.includes("managed-child-billing-locked")) return "managed-child-billing-locked";
    if (text.includes("managed-child-family-role-locked")) return "managed-child-family-role-locked";
    if (text.includes("already-linked-other")) return "already-linked-other";
  }
  return "";
}

/**
 * @param {unknown} reason
 * @returns {string} i18n key or empty
 */
export function resolveClubPersonBillingAssignmentErrorKey(reason) {
  switch (__asStr(reason)) {
    case "billing-recipient-already-assigned":
      return "admin.people.errors.billingRecipientAlreadyAssigned";
    case "guardian-already-assigned":
      return "admin.people.errors.guardianAlreadyAssigned";
    case "managed-child-billing-locked":
      return "admin.people.errors.managedChildBillingLocked";
    case "managed-child-family-role-locked":
    case "managed-child-role-locked":
      return "admin.people.errors.managedChildFamilyRoleLocked";
    case "already-linked-other":
      return "trainerstunden.family.childInvite.errors.alreadyLinkedOther";
    default:
      return "";
  }
}
